import moment from "moment";
const timeFormatter = (time: string) => moment(new Date(time)).fromNow();

export default timeFormatter;
